/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_Running_NowInputs */

const vi_trip_running_now = /** @type {(inputs: Trip_Running_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang chạy`)
};

/**

* @param {Trip_Running_NowInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_running_now = /** @type {((inputs?: Trip_Running_NowInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_Running_NowInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_running_now(inputs)
});